import { render, staticRenderFns } from "./HardwaresLayout.vue?vue&type=template&id=c4b3807c&scoped=true&"
import script from "./HardwaresLayout.vue?vue&type=script&lang=js&"
export * from "./HardwaresLayout.vue?vue&type=script&lang=js&"
import style0 from "./HardwaresLayout.vue?vue&type=style&index=0&id=c4b3807c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b3807c",
  null
  
)

export default component.exports